import React from 'react';
import { OptionText, ToggleContainer, ToggleOption } from './styled';

interface ToggleProps {
  options: { id: string; name: string }[];
  selectedValue: string;
  cypress?: string;
  onChange: (value: string) => void;
  stat?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  options,
  selectedValue,
  cypress,
  stat,
  onChange
}) => {
  const handleContainerClick = () => {
    const currentIndex = options.findIndex(o => o.id === selectedValue);
    const nextIndex = (currentIndex + 1) % options.length;
    onChange(options[nextIndex].id);
  };

  return (
    <ToggleContainer data-cy={cypress} onClick={handleContainerClick}>
      {options.map(option => {
        const isSelected = option.id === selectedValue;
        const optionCypress = `${cypress}${isSelected ? '-active' : ''}-option`;

        return (
          <ToggleOption
            key={option.id}
            $isSelected={isSelected}
            onClick={e => {
              e.stopPropagation();
              onChange(option.id);
            }}
            data-cy={optionCypress}
            data-stat={stat}
          >
            <OptionText tag="body_1" $isSelected={isSelected}>
              {option.name}
            </OptionText>
          </ToggleOption>
        );
      })}
    </ToggleContainer>
  );
};
